/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Original_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Original Language" |
*
* @param {Knp_Guide_Original_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_original_language_label = /** @type {((inputs?: Knp_Guide_Original_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Original_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue d’origine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originalsprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оригинальный язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原文")
	if (locale === "ja") return /** @type {LocalizedString} */ ("原文")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Língua original")
	return /** @type {LocalizedString} */ ("Original Language")
});